import HomeFeaturedPage from "./Featured";
import HomeTechnologyPage from "./Technology";
import HomePrivateHealthcarePage from "./PrivateHealthcare";
import HomeCrossoverPublicHealthcarePage from "./CrossoverPublicHealthcare";
import React from "react";

export const HomeContent = ({tiles, title}) => {
    switch (title) {
        case 'Technology':
            return (
                <HomeTechnologyPage data={tiles}/>
            )
        case 'Private Healthcare':
            return (
                <HomePrivateHealthcarePage data={tiles}/>
            )
        case 'Public Healthcare':
            return (
                <HomeCrossoverPublicHealthcarePage data={tiles}/>
            )
        default:
            return (
                <HomeFeaturedPage data={tiles}/>
            )
    }
}